import React from 'react'
import type { NamedIconPropsType } from './types'
import { IconSize } from './types'

const NamedIconHoC: React.FC<NamedIconPropsType> = ({
  size = IconSize.medium,
  className = '',
  onClick,
  children,
  outline = false,
  rtl = false,
  ...props
}) => {
  return (
    <span
      className={className}
      data-size={size}
      data-rtl={rtl}
      data-outline={outline}
      onClick={onClick ? onClick : undefined}
      {...props}
    >
      {children}
    </span>
  )
}

export default NamedIconHoC
